import { createContext } from 'react';

/**
 * Bounded intake views use the actual space provided by AppFrame. Sections
 * own that height and pass 100% to the nested form slot. Public or isolated
 * embeds fall back to the dynamic viewport when no app frame is present.
 */
export const DEFAULT_INTAKE_SHELL_HEIGHT = 'var(--app-content-height, 100dvh)';

/**
 * Flow with the page instead of owning a scrollport: the shell grows to its
 * content, the rail sticks to the top of the page scrollport, and the
 * Back/Continue slot sticks to the page bottom.
 */
export const FLOW_INTAKE_SHELL_HEIGHT = 'auto';

export const IntakeShellHeightContext = createContext<string>(DEFAULT_INTAKE_SHELL_HEIGHT);
